// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'pen';

export const Component = () => (
  <path d='M16.171 4.39 17.561 3l3.495 3.448L7.36 20.146l-1.725-.335-1.245 1.198-1.054-.336L3 19.62l1.245-1.198-.383-1.724 11.64-11.639-.67-.67-6.945 6.945-.719-.72L14.782 3l1.39 1.39ZM5.443 18.612l1.82.288L18.277 7.838l-2.06-2.06L5.156 16.794l.288 1.82ZM16.89 5.107l2.107 2.06.67-.72-2.06-2.059-.718.719Z' />
);

export const viewBox = '0 0 25 25';
